import { Drawer, Loader, Skeleton } from "@mantine/core";
import Link                         from "next/link";

import { useGetIsWebview } from "_common/hooks/global";
import { PrimaryButton }   from "_components/atoms/button";
import Icon                from "_components/atoms/icon";
import Image               from "_components/atoms/image";
import Render              from "_components/atoms/render";
import TabEmptyState       from "_components/atoms/tabEmptyState/container";
import Typography          from "_components/atoms/typography";

import useStyles from "../styles";

export const LeaderboardContent = ( { data, loading } ) => {
	const { classes } = useStyles ( {}, { name: "creatorLeaderboard" } );
	const topRankers  = data?.topRankers;

	if ( loading )
		return (
			<div className = { classes.innerContainer }>

				<div className = { classes.priorityBox }>
					<Image
						className = { classes.trophyImage }
						src       = { "/icons/trophy.webp" }
					/>

					<div className = { classes.topContent }>
						<div>
							<Loader
								color   = "white"
								type    = "dots"
							/>
						</div>

					</div>
				</div>

				<div className = { classes.listContainer }>
					<UserCard
						loading = { loading }
					/>

					<UserCard
						loading = { loading }
					/>

					<UserCard
						loading = { loading }
					/>

					<UserCard
						loading = { loading }
					/>

					<UserCard
						loading = { loading }
					/>

					<UserCard
						loading = { loading }
					/>

				</div>

			</div>
		);

	return (
		<div className = { classes.innerContainer }>
			{data?.banner && (
				<div className = { classes.priorityBox }>
					<Image
						className = { classes.trophyImage }
						src       = { "/icons/trophy.webp" }
					/>

					<div className = { classes.topContent }>
						<Typography
							color  = "white"
							size   = "sm"
							title  = { data?.banner?.heading || "" }
							weight = "500"
						/>

						<Typography
							color  = "white"
							mt     = "0"
							size   = "sm"
							title  = { data?.banner?.subHeading || "" }
							weight = "500"
						/>

						<Typography
							color  = "white"
							mt     = "0.2rem"
							size   = "24px"
							title  = { data?.banner?.amount ? `₹ ${ data?.banner?.amount }` : "" }
							weight = "bold"
						/>
					</div>
				</div>
			)}

			<div className = { classes.listContainer }>
				{topRankers?.length > 0 ? topRankers?.map ( ( item, idx ) => {
					const rank = item?.rank;

					return (
						<UserCard
							key  = { idx }
							item = { item }
							rank = { rank }
						/>
					);
				} ) : <TabEmptyState />}

			</div>

		</div>
	);
};

export const UserCard = ( { item, rank, loading } ) => {

	const { classes } = useStyles ( { }, { name: "creatorLeaderboard" } );
	const isWebview   = useGetIsWebview ();

	if ( loading )
		return (
			<div
				className = { classes.itemCard }
			>
				<div className = { classes.itemLeft }>
					<div className = { classes.rank }>
						<Skeleton
							h      = "25px"
							radius = { "0.5rem" }
							w      = "30px"
						/>
					</div>

					<Skeleton
						className = { classes.itemPhoto }
					/>

					<div className = { classes.itemDetails }>
						<Skeleton
							h      = "25px"
							radius = { "0.5rem" }
							w      = "50vw"
						/>

					</div>
				</div>

				<div className = { classes.itemRight }>
					<Skeleton
						h      = "25px"
						radius = { "0.5rem" }
						w      = "30px"
					/>
				</div>

			</div>
		);

	if ( !item )
		return null;

	return (
		<div
			className = { classes.itemCard }
		>
			<div className = { classes.itemLeft }>
				<div className = { classes.rank }>
					{
						typeof rank !== "number" ? (
							<Typography
								className = { classes.rank }
								title     = { "-" }
							/>
						) :
							rank > 3 ?
								(
									<Typography
										className = { classes.rank }
										title     = { `#${ zeroPad ( rank, 2 ) }` }
									/>
								)
								:
								rank === 1 ? (
									<Icon sameInBothTheme
										name = "fanRank1"
										size = { 24 }
									/>
								)
									: rank === 2 ? (
										<Icon sameInBothTheme
											name = "fanRank2"
											size = { 24 }
										/>
									)
										: (
											<Icon sameInBothTheme
												name = "fanRank3"
												size = { 24 }
											/>
										)
					}
				</div>

				<Render condition = { !isWebview }>
					<Link
						className = { classes.itemPhotoContainer }
						href      = { `/profile/${ item?.userId }` }
					>
						<Image
							className   = { classes.itemPhoto }
							placeholder = "/images/square-placeholder.webp"
							src         = { item.photo }
							type        = "mdpi"
						/>

					</Link>
				</Render>

				<Render condition = { isWebview }>
					<Image
						className   = { classes.itemPhoto }
						placeholder = "/images/square-placeholder.webp"
						src         = { item.photo }
						type        = "mdpi"
					/>
				</Render>

				<div className = { classes.itemDetails }>
					<Typography
						title  = { item.name }
						weight = "500"
					/>
				</div>
			</div>

			<div className = { classes.itemRight }>
				<Typography
					className = { classes.donationText }
					size      = "xs"
					ta        = "end"
					title     = { item?.donation_recieved ? "Donation" : "Score" }
				/>

				<div className = { classes.donationContainer }>
					{ item?.donation_recieved && (
						<Icon sameInBothTheme
							name = "diamond"
							size = { 12 }
						/>
					)}

					<Typography
						className = { classes.donation }
						size      = "sm"
						title     = { kFormatter ( item.donation_recieved || item.score ) }
					/>

				</div>
			</div>

		</div>
	);
};

export const zeroPad = ( num, places ) => String ( num ).padStart ( places, "0" );

function kFormatter ( num ) {
	if ( !num )
		return "";

	return Math.abs ( num ) > 999 ?
		Math.sign ( num ) * ( ( Math.abs ( num ) / 1000 ).toFixed ( 1 ) ) + "k" :
		Math.sign ( num ) * Math.abs ( num );
}

export const InfoDrawer = ( { opened, setOpened, data } ) => {
	const { classes } = useStyles ( {}, { name: "creatorLeaderboard" } );

	return (
		<Drawer
			classNames      = { { inner: classes.drawerInner, content: classes.drawerContent } }
			onClose         = { () => {
				setOpened ( false );
			} }
			opened          = { opened }
			position        = "bottom"
			withCloseButton = { false }
			withinPortal    = { false }
		>
			<div className = { classes.drawerHeader }>
				<Typography
					size   = "lg"
					title  = { "Information" }
					weight = "500"
				/>

				<Icon
					name    = "cross"
					onClick = { () => setOpened ( false ) }
					size    = { 24 }
				/>
			</div>

			<div className = { classes.infoContainer }>
				<ul className = { classes.infoList }>
					{data?.map ( ( item, idx ) => {
						return (
							<li
								key       = { idx }
								className = { classes.infoItem }
							>
								<Typography
									className = { classes.infoItem }
									size      = "sm"
									title     = { item }
								/>
							</li>
						);
					} )}

				</ul>

				<PrimaryButton
					fullWidth
					onClick = { () => setOpened ( false ) }
					title   = { "Okay" }
				/>
			</div>
		</Drawer>
	);

};
